import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { formSubmittedEventName, formEditingCancelledEventName } from "../../Components/ViewOrEditForm/ViewOrEditFormController";
import { JobDetail } from '../../scripts/jobCompletion';
import { reloadWithTurbo } from '../../scripts/turboHelper';


export default class CompanyCreateOrEditController extends Controller {
    static values = {
        isCreate: Boolean,
        editCompanyUrl: String,
        companyEntityName: String
    };

    readonly isCreateValue!: boolean;
    readonly editCompanyUrlValue!: string;
    readonly companyEntityNameValue!: string;

    connect() {
        this.element.addEventListener(formSubmittedEventName, this.onFormSubmitted.bind(this), {});
        this.element.addEventListener(formEditingCancelledEventName, this.onFormEditingCancelled.bind(this), {});
    }

    onFormSubmitted(event) {
        if (this.isCreateValue) {
            const job = event.detail as JobDetail;
            const companyId = job.affectedAggregateRootEntities.find(e => e.aggregateRootEntityName === this.companyEntityNameValue)?.aggregateRootEntityId;
            if (!companyId) throw new Error("Cannot read created company id.");

            const editCompanUrl = this.editCompanyUrlValue.replace("$id", `${companyId}`);
            Turbo.visit(editCompanUrl);
        } else {
            reloadWithTurbo();
        }
    }

    onFormEditingCancelled() {
        if (this.isCreateValue) {
            history.back();
        }
        else {
            reloadWithTurbo();
        }
    }
}
